import React, { FC, ReactElement, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ShoppingOutlined } from "@ant-design/icons";
import { Spin, Card } from "antd";

import {
  selectIsOrdersLoading,
  selectOrders,
} from "../../../redux-toolkit/orders/orders-selector";
import { fetchAllUsersOrders } from "../../../redux-toolkit/orders/orders-thunks";
import { resetOrders } from "../../../redux-toolkit/orders/orders-slice";
import ContentTitle from "../../../components/ContentTitle/ContentTitle";
import OrdersTable from "../../../components/OrdersTable/OrdersTable";

const OrdersList: FC = (): ReactElement => {
  const dispatch = useDispatch();
  const adminOrders = useSelector(selectOrders);
  const isOrderLoading = useSelector(selectIsOrdersLoading);

  useEffect(() => {
    // Fetch orders when component mounts
    dispatch(fetchAllUsersOrders(0));

    // Clean up state on unmount
    return () => {
      dispatch(resetOrders());
    };
  }, [dispatch]);

  return (
    <div
      style={{
        padding: "24px",
        background: "#fff",
        borderRadius: "8px",
        boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
        width: "100%",
        overflowX: "auto",
      }}
    >
      <div
        style={{
          marginBottom: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <ContentTitle
          title="List of all orders"
          titleLevel={4}
          icon={<ShoppingOutlined />}
        />
      </div>

      <Card bordered={false} bodyStyle={{ padding: 0, overflowX: "auto" }}>
        <div style={{ minWidth: 700 }}>
          {isOrderLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "300px",
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <OrdersTable
              orders={adminOrders}
              loading={isOrderLoading}
              fetchOrders={fetchAllUsersOrders}
            />
          )}
        </div>
      </Card>
    </div>
  );
};

export default OrdersList;
